export default __webpack_public_path__ + "dded4b11e43f8e06f741c192083f168a.coffee";